// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* NOTE:
Edited to add input-range-small
*/

/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* ACTUALLY, THIS IS EDITED ;)
THIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST
GRID UNITS.

ALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM \`layout-contents.js\`*/

/* layout contants from \`layout-constants.js\`, minus 1px */

/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* 35% transparent version of looks-secondary */

.input_input-form_n9yO1 {
  height: 2rem;
  padding: 0 0.75rem;

  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 0.75rem;
  font-weight: bold;
  color: var(--paint-text-primary, #575e75);
  background-color: var(--paint-input-background, #ffffff);

  border-width: 1px;
  border-style: solid;
  border-color: var(--paint-form-border, #e9eef2);
  border-radius: 2rem;

  outline: none;
  cursor: text;
  -webkit-transition: 0.25s ease-out;
  transition: 0.25s ease-out; /* @todo: standardize with var */
  -webkit-box-shadow: none;
          box-shadow: none;

  /*
        For truncating overflowing text gracefully
        Min-width is for a bug: https://css-tricks.com/flexbox-truncated-text
        @todo: move this out into a mixin or a helper component
    */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.input_input-form_n9yO1:hover {
  border-color: var(--paint-looks-secondary, #855cd6);
}

.input_input-form_n9yO1:focus {
  border-color: var(--paint-looks-secondary, #855cd6);
  -webkit-box-shadow: 0 0 0 0.25rem var(
  --paint-looks-transparent,
  hsla(260, 60%, 60%, 0.35)
);
          box-shadow: 0 0 0 0.25rem var(
  --paint-looks-transparent,
  hsla(260, 60%, 60%, 0.35)
);
}

.input_input-small_tk0qf {
  width: 3rem;
  text-align: center;
}

.input_input-small-range_OggEI {
  width: 4rem;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/forms/input.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD;;CAEC;;AAED;;oDAEoD;;AAEpD;;;;kFAIkF;;AAElF,0DAA0D;;AAE1D;;oDAEoD;;AAEpD,+CAA+C;;AAE/C;EACE,YAAY;EACZ,kBAAkB;;EAElB,2DAA2D;EAC3D,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC,wDAAwD;;EAExD,iBAAiB;EACjB,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;;EAEnB,aAAa;EACb,YAAY;EACZ,kCAAkC;EAClC,0BAA0B,EAAE,gCAAgC;EAC5D,wBAAwB;UAChB,gBAAgB;;EAExB;;;;KAIG;EACH,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;EACnD;;;CAGD;UACS;;;CAGT;AACD;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* NOTE:\nEdited to add input-range-small\n*/\n\n/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* ACTUALLY, THIS IS EDITED ;)\nTHIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST\nGRID UNITS.\n\nALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM `layout-contents.js`*/\n\n/* layout contants from `layout-constants.js`, minus 1px */\n\n/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* 35% transparent version of looks-secondary */\n\n.input-form {\n  height: 2rem;\n  padding: 0 0.75rem;\n\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 0.75rem;\n  font-weight: bold;\n  color: var(--paint-text-primary, #575e75);\n  background-color: var(--paint-input-background, #ffffff);\n\n  border-width: 1px;\n  border-style: solid;\n  border-color: var(--paint-form-border, #e9eef2);\n  border-radius: 2rem;\n\n  outline: none;\n  cursor: text;\n  -webkit-transition: 0.25s ease-out;\n  transition: 0.25s ease-out; /* @todo: standardize with var */\n  -webkit-box-shadow: none;\n          box-shadow: none;\n\n  /*\n        For truncating overflowing text gracefully\n        Min-width is for a bug: https://css-tricks.com/flexbox-truncated-text\n        @todo: move this out into a mixin or a helper component\n    */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.input-form:hover {\n  border-color: var(--paint-looks-secondary, #855cd6);\n}\n\n.input-form:focus {\n  border-color: var(--paint-looks-secondary, #855cd6);\n  -webkit-box-shadow: 0 0 0 0.25rem var(\n  --paint-looks-transparent,\n  hsla(260, 60%, 60%, 0.35)\n);\n          box-shadow: 0 0 0 0.25rem var(\n  --paint-looks-transparent,\n  hsla(260, 60%, 60%, 0.35)\n);\n}\n\n.input-small {\n  width: 3rem;\n  text-align: center;\n}\n\n.input-small-range {\n  width: 4rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-form": `input_input-form_n9yO1`,
	"inputForm": `input_input-form_n9yO1`,
	"input-small": `input_input-small_tk0qf`,
	"inputSmall": `input_input-small_tk0qf`,
	"input-small-range": `input_input-small-range_OggEI`,
	"inputSmallRange": `input_input-small-range_OggEI`
};
export default ___CSS_LOADER_EXPORT___;
